/** A permission rule as `/api/me` gives it, for keeping the menu honest. The server refuses whatever this gets wrong. */
export interface AbilityRule {
  action: string | string[];
  subject: string | string[];
}

/** Whether the rules hold any of these actions on this subject, directly or through `manage` on everything. */
export function holds(rules: readonly AbilityRule[], actions: readonly string[], subject: string): boolean {
  return rules.some((r) => [r.action].flat().some((a) => actions.includes(a)) && [r.subject].flat().some((s) => s === 'all' || s === subject));
}
